export default "__VITE_ASSET__BciLepJu__"